import checkMarkTealImg from "assets/checkmark_teal.svg";
import exCrossImg from "assets/mfi_post_ex_cross.svg";
import React, { Component } from "react";
import { strings } from "../../../constants/strings";

import { CSSTransition } from "react-transition-group";

export default class Variants extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className='variants'>
        {this.props.questions[this.props.currentQuestionIndex].variants.map(
          (answer, index) => {
            let indexArray = ["A", "B", "C", "D"];

            if (!this.props.answerKey) {
              return (
                <div
                  key={answer.title}
                  className="wpm-answer-field"
                  answerkey={indexArray[index]}
                >
                  <button
                    className="wpm-button green"
                    onClick={() =>
                      this.props.onAnswerClick(
                        answer.isRight,
                        indexArray[index]
                      )
                    }
                  >
                    {indexArray[index]}
                  </button>
                  <div className="wpm-answer-text">{answer.title}</div>
                </div>
              );
            } else {
              if (this.props.answerKey === indexArray[index]) {
                let answerClass = "wpm-answer-field "
                if (index === 1)
                  answerClass += "wpm-answered-b"
                else if (index === 2)
                  answerClass += "wpm-answered-c"
                else if (index === 3)
                  answerClass += "wpm-answered-d"
                return (
                  <div
                    key={answer.title}
                    className={answerClass}
                    answerkey={indexArray[index]}
                  >
                    <button className={this.props.showAnswerRight ? "wpm-button wpm-btn-right" : "wpm-button wpm-btn-wrong"}>
                      {this.props.showAnswerRight ? <img src={checkMarkTealImg} width="22" alt="green checkmark"></img> :
                        <img src={exCrossImg} width="26" alt="red cross"></img>}
                    </button>
                    <div className="wpm-answer-text">{answer.title}</div>
                  </div>
                );
              } else {
                return (
                  <div
                    key={answer.title}
                    className="wpm-answer-field-out"
                    answerkey={indexArray[index]}
                  >
                    <button
                      className="wpm-button green"
                      onClick={() =>
                        this.props.onAnswerClick(
                          answer.isRight,
                          indexArray[index]
                        )
                      }
                    >
                      {indexArray[index]}
                    </button>
                    <div className="wpm-answer-text">{answer.title}</div>
                  </div>
                );
              }
            }
          }
        )}
      </div>
    );
  }
}
